import currency from '../data/currency'

const getCurrencySymbol = (code) => currency[code]?.symbol || code

export default getCurrencySymbol
